import { getSocio } from '../../api/miembros/miembroSocio';
import { MiembroSocio } from '../../types/socio/socio';
import createApiModule from '../createApiModule';
import { t } from '../../i18n';

const getMiembroSocioModule = createApiModule({
  name: 'miembroSocio',
  initialData: {} as MiembroSocio,
  apiMethod: getSocio,
  parse: (data) => data,
  onError: () => ({
    message: t(
      'StoreMiembrosGetMiembroSocioModuleErrorRecuperandoSusDatosDeSocioA',
    ),
  }),
  onSuccess: () => {},
});

export const {
  start: getMiembroSocio,
  success: getMiembroSocioOk,
  error: getMiembroSocioErrors,
  refresh: getMiembroSocioRefresh,
} = getMiembroSocioModule.slice.actions;

export default getMiembroSocioModule;
